
export default function Collage1Module(element) {
    // let minPerspective = 1000;
    // let maxPerspective = 3000;
    // let minYRotation = -30;
    // let maxYRotation = 30;

    // let minXRotation = 30;
    // let maxXRotation = -30;

    // let $wrapper = document.querySelector('.collage1__wrapper');

    // element.addEventListener('mousemove', e => {
        // let layerCenter = e.currentTarget.clientWidth / 2;
        // let perspective = linearConversion(e.x, 0, e.currentTarget.clientWidth, minPerspective, maxPerspective);
        // let yRotation = linearConversion(e.x, 0, e.currentTarget.clientWidth, minYRotation, maxYRotation);
        // let xRotation = linearConversion(e.y, 0, e.currentTarget.clientHeight, minXRotation, maxXRotation);
        // $wrapper.style.perspective = perspective + 'px';
        // $wrapper.style.transform = 'rotateY(' + yRotation + 'deg) rotateX(' + xRotation + 'deg)';
    // }, { pasive: true });

    let tl = gsap.timeline({
        defaults: {
            clearProps: true
        },
        // scrollTrigger: { trigger:$wrapper, scrub: 1 }
    });

    element.querySelectorAll('.collage1__item, .collage1__computer').forEach((elm, index) => {
        let from = 200;
        tl.from(elm, {rotate: 'random(-2, 2)', opacity: 0, y: from, duration: 1}, '<0.5')
    });
}
